import config from "assets/config";
import React, { useCallback, useEffect } from "react";
import { useRef } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import PositionService from "services/position/positionService";
import { LOGIN } from "store/actions/type/login";
import { lStorage } from "utils/storage";

const HFNAuth = (props) => {
  const apiCallCount = useRef(0);
  const history = useHistory();
  const positionService = new PositionService();
  const handleAuth = useCallback((status) => {
    const element = document.querySelector("hfn-auth");
    if (element && element.handleProfileAuthentication) {
      element.handleProfileAuthentication(status);
    }
  }, []);
  const authUsers = ["CC", "RF", "ZC", "communication_admin"];

  const isAuthorized = (positions) => {
    return positions.some((role) =>
      authUsers.includes(role.position_type_code)
    );
  };

  const getCoordinatorPosition = async (srcmToken, myInfo, role) => {
    positionService.getPosition().then(async (res) => {
      let srcm_group_ids = res.data.results.map((item) => item.srcm_group.id);
      const positionTypeCode = res?.data?.results?.[0]?.position_type_code;
      const isHasAccesss = await isAuthorized(res?.data?.results);
      if (isHasAccesss) {
        lStorage.set("authInfo", {
          ...myInfo,
          isUser: true,
          role: "Superadmin",
          token: srcmToken,
          user_type: "U",
          user_role: role,
          user_name: myInfo.name,
          srcmToken: srcmToken,
          tokenData: { accessToken: srcmToken },
          positionId: srcm_group_ids,
          coordinatorRole: positionTypeCode,
        });
        props.dispatch({
          type: LOGIN,
          payload: {
            isUser: true,
            role: "Superadmin",
            token: srcmToken,
            user_type: "U",
            user_role: role,
            user_name: myInfo?.name,
            srcmToken: srcmToken,
            tokenData: { accessToken: srcmToken },
          },
        });
        handleAuth(true);
        history.push("/template/listing");
      } else {
        handleAuth(true);
        history.push("/unauthorized");
      }
    });
  };

  const getProfile = useCallback(
    async (accessInfo) => {
      apiCallCount.current += 1;

      if (apiCallCount.current < 4) {
        try {
          const { getSRCMProfile } = await import("hfnauth/main");
          const resData = await getSRCMProfile({
            srcmBaseURL: `${config.apiURL}/`,
            xClientId: `${config.xClientIdSRCM}`,
            queryParams: [
              "name",
              "first_name",
              "middle_name",
              "last_name",
              "ref",
              "email",
              "srcm_group",
              "age",
              "gender",
              "record_type",
              "date_of_birth",
              "date_of_joining",
              "city",
              "city_id",
              "state",
              "country",
              "mobile",
              "mobile2",
              "phone",
              "user_roles",
              "user_firebase_uid",
            ].join(","),
          });
          if (resData?.data) {
            const userInfoData = resData?.data;
            if (userInfoData?.user_firebase_uid) {
              const role = userInfoData.user_roles?.includes(
                "communication_admin"
              )
                ? "communication_admin"
                : "";
              lStorage.set("authInfo", {
                ...userInfoData,
                isUser: false,
                role: "",
                token: accessInfo?.access_token,
                user_type: "U",
                user_role: role,
                user_name: userInfoData?.name,
                srcmToken: accessInfo?.access_token,
                tokenData: { accessToken: accessInfo?.access_token },
              });

              props.dispatch({
                type: LOGIN,
                payload: {
                  isUser: false,
                  role: "",
                  token: accessInfo?.access_token,
                  user_type: "U",
                  user_role: role,
                  user_name: userInfoData?.name,
                  srcmToken: accessInfo?.access_token,
                  tokenData: { accessToken: accessInfo?.access_token },
                },
              });
              await getCoordinatorPosition(
                accessInfo?.access_token,
                userInfoData,
                role
              );
            } else {
              await getProfile(accessInfo);
            }
          } else {
            handleAuth(false);
          }
        } catch (error) {
          handleAuth(false);
        }
      } else {
        handleAuth(false);
      }
    },
    [handleAuth]
  );

  useEffect(() => {
    import("hfnauth/main")?.then(() => {
      document.querySelector("hfn-auth").loginCallback = async (res) => {
        try {
          const accessInfo = res?.data;
          if (!accessInfo?.access_token) {
            handleAuth(false);
            return false;
          }
          await getProfile(accessInfo);
        } catch {
          handleAuth(false);
        }
        return true;
      };
    });
  }, [getProfile, handleAuth]);
  return (
    <>
      <div />
    </>
  );
};

const mapStateToProps = (state) => ({
  ld: state.loginDetails,
});

export default connect(mapStateToProps)(HFNAuth);
